import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VAutocomplete,{attrs:{"items":_vm.getServiceProviders,"item-text":"name","item-value":"id","dense":"","label":"Select Service Provider"},on:{"change":function($event){return _vm.emitServiceProviderID()}},model:{value:(_vm.serviceProviderID),callback:function ($$v) {_vm.serviceProviderID=$$v},expression:"serviceProviderID"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }